<footer>
    Botones del footer
</footer>